import React from 'react';
import { Helmet } from "react-helmet";

const PrivacyPolicy = () => {
  return (
    <>
      <Helmet>
        <title>Bromeli - Kertészeti Tanácsadó Blog</title>
        <meta name="description" content="Bromeli kertészeti blog - szakértői tanácsok, növényápolási tippek, fenntartható kertészeti megoldások és szezonális kerti kalauz." />
      </Helmet>

      <div className="privacy-policy-container" style={{ maxWidth: '900px', margin: '0 auto', padding: '40px 20px', lineHeight: '1.8' }}>
      <h1 style={{ textAlign: 'center', marginBottom: '30px', color: '#2d5a27' }}>Adatvédelmi Szabályzat</h1>
      
      <p style={{ marginBottom: '20px' }}>Utolsó frissítés: 2024. január 1.</p>
      
      <section style={{ marginBottom: '30px' }}>
        <h2 style={{ color: '#2d5a27', marginBottom: '15px' }}>1. Bevezetés</h2>
        <p>A Bromeli (a továbbiakban: "Szolgáltató", "mi") elkötelezett az Ön személyes adatainak védelme mellett. Jelen Adatvédelmi Szabályzat ismerteti, hogyan gyűjtjük, használjuk, tároljuk és védjük az Ön személyes adatait, amikor a https://bromeli.com weboldalt (a továbbiakban: "Weboldal") használja.</p>
        <p>A Weboldal használatával Ön elfogadja a jelen Adatvédelmi Szabályzatban foglaltakat. Kérjük, figyelmesen olvassa el ezt a dokumentumot.</p>
      </section>
      
      <section style={{ marginBottom: '30px' }}>
        <h2 style={{ color: '#2d5a27', marginBottom: '15px' }}>2. Adatkezelő</h2>
        <p>Az adatkezelő a Bromeli Kft. (székhely: 1011 Budapest, Fő utca 1., adószám: 12345678-2-41, e-mail: <a href="mailto:bromeli@hotmail.com">bromeli@hotmail.com</a>).</p>
      </section>
      
      <section style={{ marginBottom: '30px' }}>
        <h2 style={{ color: '#2d5a27', marginBottom: '15px' }}>3. Gyűjtött adatok típusai</h2>
        <h3>3.1. Önkéntesen megadott adatok</h3>
        <ul>
          <li>Név (vezeték- és keresztnév)</li>
          <li>E-mail cím</li>
          <li>Telefonszám (amennyiben megadja)</li>
          <li>Szállítási cím (amennyiben rendelést ad le)</li>
          <li>Fizetési adatok (bankkártya adatok, amelyeket a fizetési szolgáltató kezel)</li>
        </ul>
        
        <h3>3.2. Automatikusan gyűjtött adatok</h3>
        <ul>
          <li>IP-cím</li>
          <li>Böngésző típusa és verziója</li>
          <li>Operációs rendszer</li>
          <li>Látogatás időpontja és időtartama</li>
          <li>Megtekintett oldalak</li>
          <li>Kattintási adatok</li>
          <li>Cookie-k segítségével gyűjtött adatok</li>
        </ul>
      </section>
      
      <section style={{ marginBottom: '30px' }}>
        <h2 style={{ color: '#2d5a27', marginBottom: '15px' }}>4. Az adatgyűjtés célja</h2>
        <p>Az adatokat az alábbi célokra használjuk fel:</p>
        <ul>
          <li>A Weboldal megfelelő működésének biztosítása</li>
          <li>Felhasználói fiók létrehozása és kezelése</li>
          <li>Rendelések feldolgozása és teljesítése</li>
          <li>Hírlevél küldése (kizárólag kifejezett hozzájárulás esetén)</li>
          <li>Kapcsolatfelvétel és ügyfélszolgálat</li>
          <li>Statisztikai elemzések és a Weboldal fejlesztése</li>
          <li>Jogi kötelezettségek teljesítése</li>
          <li>Csalás megelőzése és biztonsági okok</li>
        </ul>
      </section>
      
      <section style={{ marginBottom: '30px' }}>
        <h2 style={{ color: '#2d5a27', marginBottom: '15px' }}>5. Jogalapok</h2>
        <p>Az adatkezelés jogalapjai:</p>
        <ul>
          <li><strong>Hozzájárulás:</strong> Hírlevél küldése, marketing célú megkeresések</li>
          <li><strong>Szerződés teljesítése:</strong> Rendelések feldolgozása, szolgáltatások nyújtása</li>
          <li><strong>Jogi kötelezettség:</strong> Számviteli és adózási kötelezettségek</li>
          <li><strong>Jogos érdek:</strong> Biztonság, statisztika, Weboldal fejlesztése</li>
        </ul>
      </section>
      
      <section style={{ marginBottom: '30px' }}>
        <h2 style={{ color: '#2d5a27', marginBottom: '15px' }}>6. Cookie-k és hasonló technológiák</h2>
        <p>A Weboldal cookie-kat és hasonló technológiákat használ a felhasználói élmény javítása érdekében. A cookie-k kis adatfájlok, amelyeket a böngészője tárol. Az alábbi típusú cookie-kat használjuk:</p>
        <ul>
          <li><strong>Alapvető cookie-k:</strong> A Weboldal működéséhez szükségesek</li>
          <li><strong>Analitikai cookie-k:</strong> A látogatottság mérésére (pl. Google Analytics)</li>
          <li><strong>Marketing cookie-k:</strong> Reklámok személyre szabására (pl. Facebook Pixel)</li>
          <li><strong>Preferencia cookie-k:</strong> A beállítások megjegyzésére</li>
        </ul>
        <p>Ön a böngésző beállításaiban bármikor letilthatja a cookie-k használatát, azonban ez befolyásolhatja a Weboldal működését.</p>
      </section>
      
      <section style={{ marginBottom: '30px' }}>
        <h2 style={{ color: '#2d5a27', marginBottom: '15px' }}>7. Adatok megosztása harmadik felekkel</h2>
        <p>Az adatokat csak a következő esetekben osztjuk meg harmadik felekkel:</p>
        <ul>
          <li><strong>Fizetési szolgáltatók:</strong> A fizetések feldolgozásához</li>
          <li><strong>Szállítmányozási partnerek:</strong> A rendelések kézbesítéséhez</li>
          <li><strong>IT-szolgáltatók:</strong> Tárhelyszolgáltatás, karbantartás</li>
          <li><strong>Analitikai szolgáltatók:</strong> Google Analytics, Facebook Pixel</li>
          <li><strong>Hatóságok:</strong> Jogszabályi kötelezettség esetén</li>
        </ul>
        <p>A harmadik felek kizárólag a megadott célokra használhatják fel az adatokat, és kötelesek azokat bizalmasan kezelni.</p>
      </section>
      
      <section style={{ marginBottom: '30px' }}>
        <h2 style={{ color: '#2d5a27', marginBottom: '15px' }}>8. Adatok tárolása és biztonsága</h2>
        <p>Személyes adatait biztonságos szervereken tároljuk, és minden ésszerű technikai és szervezési intézkedést megteszünk azok védelme érdekében. Az adatokhoz kizárólag az arra jogosult munkatársaink férhetnek hozzá.</p>
        <p>Az adatokat az alábbi ideig tároljuk:</p>
        <ul>
          <li>Számlázási adatok: 8 év (számviteli jogszabályok szerint)</li>
          <li>Felhasználói fiók adatai: a fiók törléséig</li>
          <li>Hírlevél adatok: a leiratkozásig</li>
          <li>Cookie-k: a böngésző bezárásáig vagy a lejárati ideig</li>
        </ul>
      </section>
      
      <section style={{ marginBottom: '30px' }}>
        <h2 style={{ color: '#2d5a27', marginBottom: '15px' }}>9. Az Ön jogai</h2>
        <p>Az Ön adatvédelmi jogai az alábbiak:</p>
        <ul>
          <li><strong>Hozzáférés:</strong> Kérheti, hogy tájékoztassuk a kezelt adatairól</li>
          <li><strong>Helyesbítés:</strong> Kérheti a pontatlan adatok javítását</li>
          <li><strong>Törlés:</strong> Kérheti adatai törlését (a jogszabályi kötelezettségek kivételével)</li>
          <li><strong>Adathordozhatóság:</strong> Kérheti adatai átadását más szolgáltatónak</li>
          <li><strong>Korlátozás:</strong> Kérheti az adatkezelés korlátozását</li>
          <li><strong>Tiltakozás:</strong> Tiltakozhat az adatkezelés ellen</li>
          <li><strong>Hozzájárulás visszavonása:</strong> Bármikor visszavonhatja hozzájárulását</li>
        </ul>
        <p>Jogainak gyakorlásához írjon az <a href="mailto:bromeli@hotmail.com">bromeli@hotmail.com</a> e-mail címre. Panasz esetén az adatvédelmi hatósághoz (NAIH) is fordulhat.</p>
      </section>
      
      <section style={{ marginBottom: '30px' }}>
        <h2 style={{ color: '#2d5a27', marginBottom: '15px' }}>10. Google Analytics és Facebook Pixel</h2>
        <p>A Weboldal Google Analytics és Facebook Pixel szolgáltatásokat használ a látogatottság mérésére és a marketing kampányok hatékonyságának elemzésére. Ezek a szolgáltatások cookie-kat használnak, és anonimizált adatokat gyűjtenek a felhasználói viselkedésről.</p>
        <p>A Google Analytics adatvédelmi szabályzatáról itt tájékozódhat: https://policies.google.com/privacy</p>
        <p>A Facebook Pixel adatvédelmi szabályzatáról itt tájékozódhat: https://www.facebook.com/privacy/policy</p>
      </section>
      
      <section style={{ marginBottom: '30px' }}>
        <h2 style={{ color: '#2d5a27', marginBottom: '15px' }}>11. Kiskorúak adatainak védelme</h2>
        <p>A Weboldal nem szolgál 16 éven aluli személyeknek. Tudatosan nem gyűjtünk adatokat kiskorúaktól. Ha tudomásunkra jut, hogy 16 éven aluli személy adatait kezeljük, azokat haladéktalanul töröljük.</p>
      </section>
      
      <section style={{ marginBottom: '30px' }}>
        <h2 style={{ color: '#2d5a27', marginBottom: '15px' }}>12. Nemzetközi adattovábbítás</h2>
        <p>Bizonyos esetekben (pl. felhőalapú szolgáltatások) az adatok az Európai Gazdasági Térségen (EGT) kívülre is továbbíthatók. Ilyen esetekben megfelelő garanciákat biztosítunk (pl. EU-s standard szerződési klauzulák).</p>
      </section>
      
      <section style={{ marginBottom: '30px' }}>
        <h2 style={{ color: '#2d5a27', marginBottom: '15px' }}>13. A szabályzat módosítása</h2>
        <p>Fenntartjuk a jogot, hogy jelen Adatvédelmi Szabályzatot bármikor módosítsuk. A módosítások a Weboldalon történő közzététellel lépnek hatályba. A jelentős változásokról e-mailben is értesítjük Önt.</p>
      </section>
      
      <section style={{ marginBottom: '30px' }}>
        <h2 style={{ color: '#2d5a27', marginBottom: '15px' }}>14. Kapcsolat</h2>
        <p>Ha bármilyen kérdése van jelen Adatvédelmi Szabályzattal kapcsolatban, forduljon hozzánk bizalommal:</p>
        <p>Bromeli Kft.<br/>
        1011 Budapest, Fő utca 1.<br/>
        E-mail: <a href="mailto:bromeli@hotmail.com">bromeli@hotmail.com</a><br/>
        Telefon: +36 1 234 5678</p>
      </section>
      
      <section>
        <h2 style={{ color: '#2d5a27', marginBottom: '15px' }}>15. Adatvédelmi tisztviselő</h2>
        <p>Adatvédelmi tisztviselőnk: Dr. Kovács Péter<br/>
        E-mail: <a href="mailto:bromeli@hotmail.com">bromeli@hotmail.com</a></p>
      </section>
      
      <footer style={{ marginTop: '40px', paddingTop: '20px', borderTop: '1px solid #ccc', textAlign: 'center', color: '#666' }}>
        <p>© 2024 Bromeli Kft. Minden jog fenntartva.</p>
      </footer>
    </div>
  
    </>);
};

export default PrivacyPolicy;